import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["availableSelect", "selectedSelect", "availableOptions", "selectedOptions"]

  connect() {
    this.updateButtonStates()
    
    this.availableSelectTarget.addEventListener('change', () => this.updateButtonStates())
    this.selectedSelectTarget.addEventListener('change', () => this.updateButtonStates())
    
    const form = this.element.closest('form')
    if (form) {
      form.addEventListener('submit', () => this.prepareForSubmission())
    }
  }

  prepareForSubmission() {
    Array.from(this.selectedSelectTarget.options).forEach(option => {
      option.selected = true
    })
  }

  addOne() {
    const selectedOptions = Array.from(this.availableSelectTarget.selectedOptions)
    selectedOptions.forEach(option => {
      const newOption = option.cloneNode(true)
      newOption.selected = true
      this.selectedSelectTarget.appendChild(newOption)
      option.remove()
    })
    this.updateButtonStates()
  }

  addAll() {
    const allOptions = Array.from(this.availableSelectTarget.options)
    allOptions.forEach(option => {
      const newOption = option.cloneNode(true)
      newOption.selected = true
      this.selectedSelectTarget.appendChild(newOption)
    })
    this.availableSelectTarget.innerHTML = ''
    this.updateButtonStates()
  }

  removeOne() {
    const selectedOptions = Array.from(this.selectedSelectTarget.selectedOptions)
    selectedOptions.forEach(option => {
      const newOption = option.cloneNode(true)
      newOption.selected = false
      this.availableSelectTarget.appendChild(newOption)
      option.remove()
    })
    this.updateButtonStates()
  }

  removeAll() {
    const allOptions = Array.from(this.selectedSelectTarget.options)
    allOptions.forEach(option => {
      const newOption = option.cloneNode(true)
      newOption.selected = false
      this.availableSelectTarget.appendChild(newOption)
    })
    this.selectedSelectTarget.innerHTML = ''
    this.updateButtonStates()
  }

  updateButtonStates() {
    const addOneBtn = this.element.querySelector('[data-action*="addOne"]')
    const addAllBtn = this.element.querySelector('[data-action*="addAll"]')
    const removeOneBtn = this.element.querySelector('[data-action*="removeOne"]')
    const removeAllBtn = this.element.querySelector('[data-action*="removeAll"]')

    if (addOneBtn) addOneBtn.disabled = this.availableSelectTarget.selectedOptions.length === 0
    if (addAllBtn) addAllBtn.disabled = this.availableSelectTarget.options.length === 0
    if (removeOneBtn) removeOneBtn.disabled = this.selectedSelectTarget.selectedOptions.length === 0
    if (removeAllBtn) removeAllBtn.disabled = this.selectedSelectTarget.options.length === 0
  }
} 